export default __webpack_public_path__ + "static/media/rejected.71f2f595.png";